import { Button, ButtonGroup, Heading, Text, TextButton } from '@zillow/constellation-10';
import LeaseModal from '../../../../components/Containers/LeaseModal';

type Props = {
  isOpen: boolean;
  onDiscard(): void;
  onCancel(): void;
  onSave(): void;
  disabled: boolean;
};

export default function DiscardLeaseChangesModal({ isOpen, onCancel, onDiscard, onSave, disabled }: Props) {
  return (
    <LeaseModal
      id="discard-changes"
      isOpen={isOpen}
      onClose={onCancel}
      header={<Heading level={1}>You have unsaved changes</Heading>}
      body={<Text>Do you want to discard or save your changes?</Text>}
      footer={
        <ButtonGroup aria-label="delete edits">
          <TextButton tone="brand" onClick={onDiscard} disabled={disabled}>
            Discard changes
          </TextButton>
          <Button tone="brand" emphasis="filled" onClick={onSave} loading={disabled}>
            Save changes
          </Button>
        </ButtonGroup>
      }
    />
  );
}
